




































import { DataParse } from "@wj/common";
import { Vue, Component } from "vue-property-decorator";
import { BookingReq } from "@/common/class/scheduleManagement/BookingSituation/index";
import {
  getBookingList,
  getEcahrtsList,
} from "@/api/scheduleManagement/BookingSituation/index";
import myLoading from "@/components/global/my-loading/index.vue";
import majorDistribution from "@/views/page/scheduleManagement/BookingSituation/echarts/majorDistribution/index.vue";
import * as echart from "echarts";
require("echarts/map/js/china");
require("echarts/extension/bmap/bmap");

interface nameTest {
  majorDescribe: string;
}
@Component({
  components: {
    myLoading,
    majorDistribution,
  },
})
export default class empowermentQueryComponent extends Vue {
  isRequest = false;
  req = new BookingReq();
  echartsData: Array<any> = [];
  tableloading = false;
  scheduleDialogloading = false;
  itemExecuteState = "";
  scheduleDialogVisible = false;
  tableData = new DataParse();
  Height = 250;

  created() {
    this.getList();
  }

  mounted() {
    this.getHeight();
    window.addEventListener("resize", this.getHeight, false);
  }

  getHeight() {
    //获取浏览器高度并计算得到表格所用高度。
    this.$nextTick(() => {
      this.Height = document.documentElement.clientHeight - 120;
    });
  }
  goDetail(data: any) {
    this.scheduleDialogVisible = true;
    this.itemExecuteState = data.executeState;
    this.getecharts(data.id);
  }
  getecharts(id: any) {
    this.scheduleDialogloading = true;
    let param = { id: id };
    getEcahrtsList(param)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.echartsData = [];
          if (data.data.sexData.length > 0) {
            this.echartsData.push(data.data.sexData);
          }
          if (data.data.jobData.length > 0) {
            this.echartsData.push(data.data.jobData);
          }
          if (data.data.majorData.length > 0) {
            this.echartsData.push(data.data.majorData);
          }
          if (data.data.eduData.length > 0) {
            this.echartsData.push(data.data.eduData);
          }
        } else {
          this.$message({
            type: "error",
            message: "获取图表失败",
          });
        }
      })
      .finally(() => {
        this.scheduleDialogloading = false;
      });
  }

  // 查询
  onSubmit() {
    this.req.pageNo = 1;
    this.getList();
  }

  // 重置
  reSubmit() {
    this.req = new BookingReq();
    this.getList();
  }
  // 预览文件
  fileView(val: any) {
    let url = val.attachmentAddress;
    window.open(
      `${process.env.VUE_APP_FILE_ONLINE_ADDRESS}?url=${url}`,
      "_blank"
    );
    // window.open(``, "_blank");
  }

  // 获取列表
  getList() {
    this.tableloading = true;
    getBookingList(this.req)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.tableData.listItem = data.rows;
          this.tableData.total = data.total;
          this.tableData.getNo(this.req.pageNo, this.req.pageSize);
        }
      })
      .finally(() => {
        this.tableloading = false;
      });
  }

  changePage(index: number) {
    this.req.pageNo = index;
    this.getList();
  }
}
